var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// @ts-ignore
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { Icon, } from 'elements';
import History from '../helpers/History';
import { toMoneyDecimal } from '../helpers/Format';
let TitleBar = class TitleBar extends Component {
    constructor() {
        super(...arguments);
        this.handleBack = () => {
            if (this.props.handleBack) {
                return this.props.handleBack();
            }
            History.goBack();
        };
    }
    render() {
        const { hasParent } = this.props.store.UI;
        const { total } = this.props.store.tempTicketStore.tempSaleTicket;
        const stretch = this.props.store.tempTicketStore.tempSaleTicket.getStretch();
        return (React.createElement("div", { style: {
                /*background: 'gray',*/
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
                minHeight: Theme.size.bar,
                padding: `Theme.size.space[1] 0`
            } },
            React.createElement(Left, null,
                React.createElement("div", { onClick: this.handleBack, style: {} },
                    React.createElement(StyledIcon, { name: "back", size: 25 }))),
            React.createElement(Center, null,
                React.createElement(StyledLink, { to: "/operationlines" },
                    React.createElement("img", { src: '/logo_ticando.svg', height: '40px', width: '240px', alt: 'img ticando' }))),
            React.createElement(Right, null, toMoneyDecimal(total, total > 0 ? stretch ? stretch.primaryMoney.alphabeticCode : '' : ''))));
    }
};
TitleBar = __decorate([
    inject('store'),
    observer
], TitleBar);
export default TitleBar;
const StyledLink = cxs(Link)({
    textTransform: 'none',
    ':hover': {
        textDecorationLine: 'none',
    }
});
const StyledText = cxs('p')({
    margin: 0,
    ':hover': {
        color: Theme.color.primary,
    },
});
const StyledIcon = cxs(Icon)({
    /*position: 'relative',*/
    /*top: '50%',*/
    /*transform: 'translateY(-50%)',*/
    ':hover': {
        color: Theme.color.primary
    },
});
const Left = props => (React.createElement("div", Object.assign({}, props, { style: {
        flex: 1,
        textAlign: 'start',
        paddingLeft: '10px',
    } })));
const Center = props => (React.createElement("div", Object.assign({}, props, { style: {
        textAlign: 'center',
        flex: 4,
    } })));
const Right = props => (React.createElement("div", Object.assign({}, props, { style: {
        flex: 1,
        textAlign: 'center',
        color: Theme.color.primary
    } })));



//////////////////
// WEBPACK FOOTER
// ./src/components/TitleBar.tsx
// module id = 552
// module chunks = 0